import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SortComponent } from "./sort.component";
import { CheckboxModule } from "../checkbox/checkbox.module";
import { FormsModule } from "@angular/forms";
import { IconModule } from "../icon/icon.module";

@NgModule({
	declarations: [SortComponent],
	imports: [CommonModule, CheckboxModule, FormsModule, IconModule],
	exports: [SortComponent]
})
export class SortModule {}
